import { AppProjectAbility, _entries } from '@common';
import { JWTPayload } from '@common';
import { AppProject } from '@common';
import { selectAuthUser } from '@pages/Authentication/store/selectors';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';

export function useAppProjectAbility() {
    const user = useSelector(selectAuthUser);
    return useMemo(
        () =>
            user
                ? AppProjectAbility(new JWTPayload(user?.id?.toString(), user?.email, user?.role), AppProjectClone as any)
                : null,
        [user]
    );
}

export class AppProjectClone {
    constructor(appProject?: AppProject) {
        _entries(appProject).forEach(([key, value]) => {
            (this as any)[key] = value;
        });
    }
}
